module.exports = __webpack_public_path__ + "static/media/thumb.deddebb1.jpg";